import { connect } from 'react-redux';

import OAuthLoginPage from '../components/OAuthLoginPage/OAuthLoginPage';

const mapStateToProps = () => {};

export default connect(mapStateToProps)(OAuthLoginPage);
